import { useDocumentVisibility, useIdle, useIntervalFn } from '@vueuse/core'
import { ref } from 'vue'
import { useTitropEvents } from '@/composables/useTitropEvents.ts'

interface ActivityTrackerOptions {
  pingIntervalMs?: number
  idleAfterSeconds?: number
  onPing: () => void
  debug?: boolean
}

const isLoggedIn = ref(false)
useTitropEvents().onLoginSuccess.on(() => {
  isLoggedIn.value = true
})
useTitropEvents().onLogout.on(() => {
  isLoggedIn.value = false
})

let isPinging = false

export function useActivityTracker(options: ActivityTrackerOptions) {
  const { pingIntervalMs = 60_000, idleAfterSeconds = 60, onPing, debug = false } = options

  const visibility = useDocumentVisibility()
  const isIdle = useIdle(idleAfterSeconds * 1000).idle
  const lastPing = ref<number | null>(null)

  const shouldPing = () => {
    if (!isLoggedIn.value || isPinging) return false
    const active = visibility.value === 'visible' && !isIdle.value
    if (debug) console.debug('[ActivityTracker] shouldPing:', active)
    return active
  }

  const { pause, resume } = useIntervalFn(
    async () => {
      if (!shouldPing() || isPinging) return

      isPinging = true
      try {
        await onPing()
        lastPing.value = Date.now()
      } catch (e) {
        console.warn('[ActivityTracker] onPing failed', e)
      } finally {
        isPinging = false
      }
    },
    pingIntervalMs,
    { immediate: true }
  )

  const unloadHandler = () => {
    if (debug) console.debug('[ActivityTracker] beforeunload')
    if (shouldPing()) {
      try {
        onPing()
        // navigator.sendBeacon?.(
        //   '/api/last-seen',
        //   JSON.stringify({
        //     timestamp: new Date().toISOString()
        //   })
        // )
      } catch (e) {
        console.warn('[ActivityTracker] sendBeacon failed', e)
      }
    }
  }

  window.addEventListener('beforeunload', unloadHandler)

  // onBeforeUnmount(() => {
  //   pause()
  //   window.removeEventListener('beforeunload', unloadHandler)
  // })

  return {
    isIdle,
    lastPing,
    pause,
    resume
  }
}
